import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from './plugins/vuetify'
import VCalendar from 'v-calendar';
import VueYouTubeEmbed from "vue-youtube-embed";
import { onAuthStateChanged} from 'firebase/auth'
import {getAuth} from "@/shared/firebase_utils";


// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.use(VueYouTubeEmbed);


Vue.config.productionTip = false
Vue.prototype.$appHostUrl = process.env.NODE_ENV == "production" ? "https://app.pappyon.com" : "https://app-staging-pappyon.web.app";

let app;


onAuthStateChanged(getAuth(), (user)=>{
  if(!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
})

